module.exports = __webpack_public_path__ + "img/jameson-form-bg-left.5c0b2dd7.png";